import React from 'react';
import { connect } from 'react-redux';
import { getCMSObject, CurrentSweepstakes, CurrentPromotions, DisplayContent } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout';

import LotteryPromotions from '../Components/MyRewardsAndPromotions/LotteryPromotions';
import promotionConfig from '../promotion_config';
import PointsForDrawingsSection from '../Components/PointsForDrawings/PointsForDrawings';

const PromotionsPage = ({ user, config, sweep, promotion, cmsSourceFirebase, actions, match, pointsForDrawings }) => {
    const telescriptCurrentSweepstakes = getCMSObject('data.components.teleScripts.currentPromotions.jsonBlock');
    const telescriptCurrentPromotions = getCMSObject('data.components.teleScripts.myRewardsHighlights.jsonBlock');

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <h1 className='text-uppercase'>My Promotions &amp; Rewards</h1>

            <section id='second-chance-promotions'>
                <CurrentSweepstakes
                    {...{ sweep, cmsSourceFirebase, actions }}
                    telescript={telescriptCurrentSweepstakes}
                    mode='show-limited'
                    options={{ hasCollapser: false, variant: 'theme-primary' }}
                />
            </section>

            <section id='my-rewards'>
                <CurrentPromotions
                    {...{ user, config, promotion, cmsSourceFirebase, actions }}
                    telescript={telescriptCurrentPromotions}
                    mode='show-limited'
                    options={{
                        hasCollapser: false,
                        showNoLimit: true,
                        variant: 'theme-primary',
                        jurisdiction: promotionConfig?.jurisdiction,
                    }}
                />
            </section>

            <DisplayContent isVisible={config?.web?.features?.pointsForDrawings}>
                <section id='points-for-drawings'>
                    <PointsForDrawingsSection {...{ actions, pointsForDrawings }} />
                </section>
            </DisplayContent>

            <LotteryPromotions />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionsPage);
